import { gql } from '@apollo/client';
import PRODUCT from 'api/fragments/PRODUCT';
const ADD_PRODUCT = gql `
  ${PRODUCT}
  mutation AddProduct(
    $tenantId: ID!
    $pictures: [String!]!
    $productDescription: String
    $categoryId: ID!
    $supplierId: ID!
    $name: String!
    $composition: String
    $grammage: String
    $width: String
    $componentSize: String
    $zipperType: String
    $producerCode: String
    $underSliderType: String
    $upperSliderType: String
    $yardage: String
    $properName: String
    $orderOperatorId: String!
    $productionTimeDays: Int
    $continentId: ID
    $countryId: ID
    $eventId: ID
    $mainCategoryId: ID
    $functionIds: [ID]
    $sustainabilityIds: [ID]
    $certificateIds: [ID]
  ) {
    addProduct(
      tenantId: $tenantId
      pictures: $pictures
      productDescription: $productDescription
      categoryId: $categoryId
      supplierId: $supplierId
      name: $name
      composition: $composition
      grammage: $grammage
      width: $width
      componentSize: $componentSize
      zipperType: $zipperType
      producerCode: $producerCode
      underSliderType: $underSliderType
      upperSliderType: $upperSliderType
      yardage: $yardage
      properName: $properName
      orderOperatorId: $orderOperatorId
      productionTimeDays: $productionTimeDays
      continentId: $continentId
      countryId: $countryId
      eventId: $eventId
      mainCategoryId: $mainCategoryId
      functionIds: $functionIds
      sustainabilityIds: $sustainabilityIds
      certificateIds: $certificateIds
    ) {
      product {
        ...ProductFragment
      }
    }
  }
`;
export default ADD_PRODUCT;
